import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setAuthToken } from "../utils/authSession";

const LogoutButton = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    setAuthToken(null);
    navigate("/", { replace: true });
  };

  return (
    <Button
      onClick={handleLogout}
      variant="contained"
      color="primary" // will use your theme's primary
    >
      Logout
    </Button>
  );
};

export default LogoutButton;
